module.exports = __webpack_public_path__ + "sipgate_name.svg?f91bdcd6a47d459a120d36e41678a206";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/sipgate_name.svg
// module id = 20
// module chunks = 0